import script from "./InterviewThanks.vue?vue&type=script&lang=ts&setup=true"
export * from "./InterviewThanks.vue?vue&type=script&lang=ts&setup=true"

import "./InterviewThanks.vue?vue&type=style&index=0&id=7dacc0b8&lang=scss"
import "./InterviewThanks.vue?vue&type=style&index=1&id=7dacc0b8&lang=scss&scoped=true"

import exportComponent from "D:\\a\\1\\s\\TelAvivMuseum.Web\\museum-telaviv\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7dacc0b8"]])

export default __exports__